import { defineStore } from "pinia";
import {
  getFilteredMapPolygons,
  getMapParcels,
  getMapPolygons,
  getPolygonByParcelId,
  getRegionsPolygons,
} from "@/api/apiclient/organization";
import simplify from "@turf/simplify";

import axios, { AxiosResponse } from "axios";
import { decodeCoordinatesList } from "@/utilities/functions/convertCoordinates";
import persistedState from 'pinia-plugin-persistedstate';
interface Polygon {
  type: string;
  properties: any;
  geometry: any;
}

export const usePolygon = defineStore("polygons", {
  state: () => ({
    polygons: [] as Polygon[],
    regions: [] as Polygon[],
    provinces: [] as Polygon[],
    parcels: [] as Polygon[],
    regionCounter: 0,
    provincesCounter: 0,
    myZipSelection: [] as string[],
    myPolygonsSelected: [] as number[],
    myParcelIdSelection: null,
    accordionRegions: {} as any,
    // selectionColor: "rgba(0,0,255,0.27)",
    selectionColor: "rgba(255, 0, 0,0.42)",
    defaultColor: "rgba(0, 116, 193,0.15)",
    localProvinces: [] as string[],
    selectedStatus: null,
    previousParcel: -10,
    templateColorArray: [
      { "name": "Libera", "color": "rgba(0, 116, 193,0.15)" },
      { "name": "Non presente", "color": "rgba(255,255,255,0.001)" },
      { "name": "Negozio Attivo", "color": "rgba(155,223,196,0.15)" },
      { "name": "Prenotata", "color": "rgba(255,180,79,0.15)" },
      { "name": "Selezionata", "color": "rgba(255,0,0,0.42)" }
    ],

    colorArray: [
      // "rgba(255,0,0,0.12)",      // rosso
      // "rgba(0,128,0,0.12)",      // verde
      // "rgba(0,0,255,0.12)",      // blu
      // "rgba(255,165,0,0.12)",    // arancio
      // "rgba(255,255,0,0.12)",    // giallo
      // "rgba(0,255,255,0.12)",    // ciano
      // "rgba(255,0,255,0.12)",    // magenta
      // "rgba(0,255,0,0.12)",      // lime
      // "rgba(128,0,128,0.12)",    // viola
      // "rgba(128,0,0,0.12)",      // bordeaux
      // "rgba(0,128,128,0.12)",    // teal
      // "rgba(128,128,0,0.12)",    // oliva
      // "rgba(255,192,203,0.12)",  // rosa
      // "rgba(210,105,30,0.12)",   // cioccolato
      // "rgba(70,130,180,0.12)",   // acciaio blu
      // "rgba(255,99,71,0.12)",    // pomodoro
      // "rgba(173,216,230,0.12)",  // azzurro chiaro
      // "rgba(154,205,50,0.12)",   // verde giallastro
      // "rgba(255,215,0,0.12)",    // oro
      // "rgba(47,79,79,0.12)"      // grigio ardesia scuro
      "rgba(0, 116, 193,0.15)",      // blu
    ]

  }),
  plugins: [persistedState],
  actions: {
    setSelectedStatus(status: number) {
      this.selectedStatus = status;
    },
    async updateRegions() {
      this.regionCounter++;
      this.provincesCounter = 0;

      if (this.regionCounter === 1) {
        this.polygons = [...this.regions]; // opzionale, se vuoi mostrare anche su polygonLayer
      }
    },

    async updateProvinces() {
      this.regionCounter = 0;
      this.provincesCounter++;

      if (this.provincesCounter === 1) {
        this.polygons = [...this.provinces]; // opzionale
      }
    },
    async resetCounters() {
      this.regionCounter = 0
      this.provincesCounter = 0
    },
    async updatePolygons(params: any) {
      try {
        const response = await getMapPolygons(params);
        const data = [
          // ...this.polygons.filter((el: any) => this.myZipSelection.includes(el.properties?.location?.zipCode)),
          ...this.polygons.filter((el: any) => this.myPolygonsSelected.includes(el.properties?.id)),
          ...(response?.polygons?.map((el: any) => {
            const mapped = {
              "type": "Feature",
              "properties": {
                ...el
              },
              "geometry": {
                // coordinates: JSON.parse(el?.coordinates ?? "{}")?.coordinates ?? [],
                // type: JSON.parse(el?.coordinates ?? "{}")?.type
                coordinates: decodeCoordinatesList(el?.coordinates),
                type: "MultiPolygon"
              }
            }
            // if (this.myZipSelection.includes(mapped.properties?.location?.zipCode)) {
            //   mapped.properties.color = this.selectionColor
            // }
            if (this.myPolygonsSelected.includes(mapped.properties?.id)) {
              mapped.properties.color = this.selectionColor
            }
            return mapped;
          }) ?? [])
        ];
        const first = new Set();
        this.polygons = data.filter((el: any) => {
          if (first.has(el.properties?.id)) return false;
          else {
            first.add(el.properties?.id);
            return true;
          }
        });
      } catch (error) {
        if (axios.isCancel(error)) {
          // console.log("Chiamata annullata volontariamente");
          return;
        }
        throw error;
      }
    },
    async updatePolygonsToSave(params: any) {
      try {
        let response: void | { polygons: Array<any>; } | AxiosResponse<{ polygons: Array<any>; }, any>
        if (params?.typeOfArea !== 0) {
          response = await getMapPolygons(params);
        } else {
          response = await getRegionsPolygons();
        }
        const data = [
          // ...this.polygons.filter((el: any) => this.myZipSelection.includes(el.properties?.location?.zipCode)),
          ...this.polygons.filter((el: any) => this.myPolygonsSelected.includes(el.properties?.id)),
          ...(response?.polygons?.map((el: any) => {
            const mapped = {
              "type": "Feature",
              "properties": {
                ...el
              },
              "geometry": {
                // coordinates: JSON.parse(el?.coordinates ?? "{}")?.coordinates ?? [],
                // type: JSON.parse(el?.coordinates ?? "{}")?.type
                coordinates: decodeCoordinatesList(el?.coordinates),
                type: "MultiPolygon"
              }
            }
            // if (this.myZipSelection.includes(mapped.properties?.location?.zipCode)) {
            //   mapped.properties.color = this.selectionColor
            // }
            if (this.myPolygonsSelected.includes(mapped.properties?.id)) {
              mapped.properties.color = this.selectionColor
            }
            return mapped;
          }) ?? [])
        ];
        const first = new Set();
        const uniquePolygons = data.filter((el: any) => {
          if (first.has(el.properties?.id)) return false;
          else {
            first.add(el.properties?.id);
            return true;
          }
        });
        if (params?.typeOfArea === 0) {
          this.regions = uniquePolygons

        } else if (params?.typeOfArea === 1) {
          this.provinces = uniquePolygons
        }
      } catch (error) {
        if (axios.isCancel(error)) {
          // console.log("Chiamata annullata volontariamente");
          return;
        }
        throw error;
      }
    },

    applyColorSelection() {
      const swap = [...this.polygons];
      this.polygons.length = 0;
      this.polygons = [...swap.map((el: any) => {

        // if (this.myZipSelection.includes(el.properties?.location?.zipCode)) {
        if (this.myPolygonsSelected.includes(el.properties?.id)) {
          el.properties.color = this.selectionColor
        } else {
          el.properties.color = this.defaultColor
        }
        return el;
      })]
    },
    async updatePolygonsFiltered(params: any) {
      const response = await getFilteredMapPolygons(params);
      const formattedPolygons = response?.polygons?.map((el: any) => ({
        type: "Feature",
        properties: {
          ...el
        },
        geometry: {
          // coordinates: JSON.parse(el?.coordinates ?? "{}")?.coordinates ?? [],
          // type: JSON.parse(el?.coordinates ?? "{}")?.type
          coordinates: decodeCoordinatesList(el?.coordinates),
          type: "MultiPolygon"
        }
      })) ?? [];
      this.polygons = formattedPolygons;
    },
    getZoomToMetersPerPixel(zoom: number, latitude: number = 0) {
      const earthCircumference = 40075000; // Circonferenza terrestre in metri (equatore)
      const latitudeRad = (latitude * Math.PI) / 180; // Converti latitudine in radianti
      return ((earthCircumference * Math.cos(latitudeRad)) / (Math.pow(2, zoom + 8))) * 1000;
    },
    async updateParcels(params: any, parcelId: number | any = null) {

      const response =
        !parcelId
          ? await getMapParcels(params)
          : await getPolygonByParcelId(parcelId);
      if (!parcelId) {
        this.parcels = (response?.polygons?.map((el: any) => {
          // ✅ FIX: Usa colore da status se non c'è custom color
          const statusColor = (el?.status !== undefined && el?.status !== null)
            ? this.templateColorArray[el.status]?.color
            : null;

          return {
            "type": "Feature",
            "properties": {
              color: el?.color ?? statusColor ?? this.defaultColor,
              ...el
            },
            "geometry": {
              // coordinates: JSON.parse(el?.polygonCoordinates ?? "{}")?.coordinates ?? [],
              // type: JSON.parse(el?.polygonCoordinates ?? "{}")?.type
              coordinates: decodeCoordinatesList(el?.polygonCoordinates),
              type: "MultiPolygon"
            }
          };
        }) ?? []);
      } else {
        // ✅ FIX: Usa colore da status se non c'è custom color (anche per singola particella)
        const statusColor = (response?.polygon?.status !== undefined && response?.polygon?.status !== null)
          ? this.templateColorArray[response.polygon.status]?.color
          : null;

        this.parcels = [{
          "type": "Feature",
          "properties": {
            color: response?.polygon?.color ?? statusColor ?? this.defaultColor,
            ...response?.polygon
          },
          "geometry": {
            // coordinates: JSON.parse(response?.polygon?.polygonCoordinates ?? "{}")?.coordinates ?? [],
            // type: JSON.parse(response?.polygon?.polygonCoordinates ?? "{}")?.type
            coordinates: decodeCoordinatesList(response?.polygon?.polygonCoordinates),
            type: "MultiPolygon"
          }
        }];

      }

    },
    getRandVividColor() {
      const channels = [
        Math.floor(Math.random() * 56) + 200,  // Alto (200-255)
        Math.floor(Math.random() * 101) + 100, // Medio (100-200)
        Math.floor(Math.random() * 101)        // Basso (0-100)
      ];
      for (let i = channels.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [channels[i], channels[j]] = [channels[j], channels[i]];
      }
      return `rgba(${channels[0]}, ${channels[1]}, ${channels[2]}, 0.5)`;
    },
    // async updateParcelsFiltered(params: any) {
    //   const response = await getFilteredMapParcels(params);
    //   this.parcels = (response?.polygons?.map((el: any) => ({
    //     "type": "Feature",
    //     "properties": {
    //       ...el
    //     },
    //     "geometry": {
    //       coordinates: JSON.parse(el?.coordinates ?? "{}")?.coordinates ?? [],
    //       type: JSON.parse(el?.coordinates ?? "{}")?.type
    //     }
    //   })) ?? []);
    // },
    handleZip(zipCode: string) {
      const alreadySelected = this.myZipSelection.includes(zipCode);
      if (alreadySelected) this.myZipSelection = this.myZipSelection.filter((x: string) => x !== zipCode);
      else this.myZipSelection.push(zipCode);
      this.applyColorSelection();
    },
    handleZipByID(id: number) {
      const alreadySelected = this.myPolygonsSelected.includes(id);
      if (alreadySelected) this.myPolygonsSelected = this.myPolygonsSelected.filter((x: number) => x !== id);
      else this.myPolygonsSelected.push(id);
      this.applyColorSelection();
    },
    handleID(polygonID: number, force = false) {
      if (force || this.previousParcel == this.myParcelIdSelection) {
        const alreadySelected = this.myPolygonsSelected.includes(polygonID);
        if (alreadySelected) {
          this.myPolygonsSelected = this.myPolygonsSelected.filter((x: number) => x !== polygonID);
        } else {
          this.myPolygonsSelected.push(polygonID);
        }
      } if (force) {
        this.previousParcel = -10
      } else {
        this.previousParcel = this.myParcelIdSelection!;
      }
      this.applyColorSelection();
    },
    handleIDCustom(polygonID: number) {
      const alreadySelected = this.myPolygonsSelected.includes(polygonID);
      if (alreadySelected) {
        this.myPolygonsSelected = this.myPolygonsSelected.filter((x: number) => x !== polygonID);
      } else {
        this.myPolygonsSelected.push(polygonID);
      }
      this.applyColorSelection();

    },
    // simplifyFeature(feature: Polygon, typeOfArea: number = 0) {
    //   // ~0.0005° ≈ 55 m a latitudine 45 °N.
    //   const tolerance = typeOfArea < 5 ? 0.001 : 0.0005;
    //   return simplify(feature as any, { tolerance, highQuality: false,mutate: true });



    // }
  },
  getters: {
    getPolygons: (state) => state.polygons,
    getParcels: (state) => state.parcels,
    getRegions: (state) => state.regions,
    getProvinces: (state) => state.provinces,
    getSelectedStatus: (state) => state.selectedStatus,
    getLocationFromID: (state) => (id: number) => {
      const result = state.parcels.flatMap(parcel =>
        parcel.properties.locations?.filter((loc: any) => loc.polygonId === id) ?? [])

      return result.length > 0 ? result[0].zipCode : null;
    },
    getLocationInfoFromID: (state) => (id: number) => {
      const result = state.polygons
        .find((el: any) => el.properties?.id === id)
      return result?.properties.info
    },
    getLocationsFromID: (state) => (id: number) => {
      const result = state.polygons
        .find((el: any) => el.properties?.id === id)
      return result?.properties.location
    },
    getZipCodeInfo: (state) => (zipCode: string) => {
      const res = state.polygons
        .find((el: any) => el.properties?.location?.zipCode === zipCode)
        ?.properties?.info
    },
    // getMunicipalityFromZipCode: (state) => (zipCode: string) => state.polygons
    //   .filter((el: any) => el.properties?.location?.zipCode === zipCode)
    //   .map(x => x?.properties?.name)
    //   .join(", "),
    getMunicipalityFromId: (state) => (id: number) => {
      const result = state.polygons.find(polygon =>
        polygon.properties.id === id
      );
      // console.log("MUNICIPALITY", result);
      return result?.properties?.location?.cityName;
    },
    getSelectedParcelInfo: (state) => () => state.parcels?.find((el) => el?.properties?.id === state.myParcelIdSelection)?.properties,
    getSelectedZipTotals:
      (state) => () => {
        const relevant = state.polygons.filter(f => state.myPolygonsSelected.includes(f.properties?.id));
        // const relevant = state.polygons.filter(f => state.myZipSelection.includes(f.properties?.location?.zipCode));
        const uniques = Array.from(
          new Map(
            relevant.map(f => [f.properties.id, f])
          ).values()
        );
        return uniques.reduce(
          (acc, { properties: { info } }) => ({
            houseStreetsCount: acc.houseStreetsCount + (info?.houseStreetsCount ?? 0),
            residencesCount: acc.residencesCount + (info?.residencesCount ?? 0),
            shopsCount: acc.shopsCount + (info?.shopsCount ?? 0),
            officesCount: acc.officesCount + (info?.officesCount ?? 0),
          }),
          { houseStreetsCount: 0, residencesCount: 0, shopsCount: 0, officesCount: 0 }
        );
      },
  },
});
